module.exports = __webpack_public_path__ + "img/phase1_img03.d95ebd71.png";